document.addEventListener('DOMContentLoaded', () => {
    // ── Component Logic ──────────────────────────────────
    (function () {
        'use strict';

        var DEFAULTS = {
            autoplay: true,
            autoplayDelay: 4000,
            swipeThreshold: 45,
            images: []
        };

        function mod(n, m) { return ((n % m) + m) % m; }

        function scheduleIdle(fn, timeout) {
            if ('requestIdleCallback' in window) {
                window.requestIdleCallback(fn, { timeout: timeout || 2500 });
                return;
            }
            window.setTimeout(fn, timeout || 1200);
        }

        function readConfig(root) {
            var el = root.querySelector('[data-cfs-config]');
            if (!el) return Object.assign({}, DEFAULTS);
            try {
                var user = JSON.parse(el.textContent.trim());
                return Object.assign({}, DEFAULTS, user, {
                    images: Array.isArray(user.images) ? user.images : []
                });
            } catch (e) { return Object.assign({}, DEFAULTS); }
        }

        function boot(root) {
            var track = root.querySelector('[data-cfs-track]');
            var prevBtn = root.querySelector('[data-cfs-prev]');
            var nextBtn = root.querySelector('[data-cfs-next]');
            var dotsWrap = root.querySelector('[data-cfs-dots]');

            if (!track || !prevBtn || !nextBtn || !dotsWrap) return;

            var cfg = readConfig(root);
            var total = cfg.images.length;
            if (!total) return;

            var current = Math.floor(total / 2);
            var saveData = !!(navigator.connection && navigator.connection.saveData);
            var reducedData = window.matchMedia && window.matchMedia('(prefers-reduced-data: reduce)').matches;
            var allowFullUpgrade = !saveData && !reducedData;
            var fullUpgradeStarted = false;
            var autoplayReady = false;
            var slides = [];

            /* ── Autoplay ──────────────────────────────────── */
            var timer = null;
            var paused = false;

            function arm() {
                disarm();
                if (!autoplayReady || !cfg.autoplay || total < 2 || paused) return;
                timer = setInterval(step1, cfg.autoplayDelay);
            }
            function disarm() { clearInterval(timer); timer = null; }
            function holdOn() { paused = true; disarm(); }
            function holdOff() { paused = false; arm(); }
            function rearm() { disarm(); arm(); }
            function step1() { moveTo(mod(current + 1, total)); }

            function getPosition(i) {
                var offset = i - current;
                var pos = mod(offset, total);
                if (pos > Math.floor(total / 2)) pos -= total;
                return pos;
            }

            function isNear(i) {
                return Math.abs(getPosition(i)) <= 1;
            }

            function ensurePreview(state) {
                if (!state || state.previewLoaded || !state.previewSrc) return;
                state.preview.src = state.previewSrc;
                state.previewLoaded = true;
            }

            function upgradeFull(state) {
                if (!allowFullUpgrade || !state || state.fullLoaded || state.fullLoading || !state.fullSrc) return;
                state.fullLoading = true;
                state.full.src = state.fullSrc;
                state.full.decode().catch(function () {}).then(function () {
                    state.fullLoaded = true;
                    state.full.classList.add('is-loaded');
                });
            }

            function ensureVisibleSlides() {
                slides.forEach(function (state, i) {
                    if (!isNear(i)) return;
                    ensurePreview(state);
                    if (fullUpgradeStarted) upgradeFull(state);
                });
            }

            function warmRemainingPreviews() {
                slides.forEach(function (state) {
                    ensurePreview(state);
                });
            }

            function warmFullImages() {
                if (!allowFullUpgrade) return;
                [current, mod(current - 1, total), mod(current + 1, total)].forEach(function (idx) {
                    upgradeFull(slides[idx]);
                });
                scheduleIdle(function () {
                    slides.forEach(function (state) { upgradeFull(state); });
                }, 3500);
            }

            /* ── Build DOM ─────────────────────────────────── */
            var fallbackSlide = track.querySelector('[data-cfs-fallback-slide]');
            if (fallbackSlide && fallbackSlide.parentNode) fallbackSlide.parentNode.removeChild(fallbackSlide);
            track.innerHTML = '';
            dotsWrap.innerHTML = '';

            cfg.images.forEach(function (img, i) {
                var slide = i === current && fallbackSlide ? fallbackSlide : document.createElement('div');
                slide.className = 'cfs-slide';
                slide.setAttribute('data-index', String(i));

                var media = slide.querySelector('.cfs-slide-media') || document.createElement('div');
                media.className = 'cfs-slide-media';
                media.style.cssText = 'position:absolute;inset:0;overflow:hidden;border-radius:inherit;';

                var image = media.querySelector('img') || document.createElement('img');
                image.className = 'cfs-img--preview';
                image.alt = img.alt || ('Slide ' + (i + 1));
                image.loading = i === current ? 'eager' : 'lazy';
                image.decoding = 'async';
                image.draggable = false;
                if (img.width) image.width = img.width;
                if (img.height) image.height = img.height;
                if (i === current) {
                    image.setAttribute('fetchpriority', 'high');
                    image.fetchPriority = 'high';
                }

                if (!image.parentNode) media.appendChild(image);

                var fullImage = media.querySelector('.cfs-img--full') || document.createElement('img');
                fullImage.className = 'cfs-img--full';
                fullImage.alt = '';
                fullImage.setAttribute('aria-hidden', 'true');
                fullImage.loading = 'lazy';
                fullImage.decoding = 'async';
                fullImage.draggable = false;
                if (img.width) fullImage.width = img.width;
                if (img.height) fullImage.height = img.height;
                if (!fullImage.parentNode) media.appendChild(fullImage);

                if (!media.parentNode) slide.appendChild(media);
                track.appendChild(slide);

                slides[i] = {
                    slide: slide,
                    preview: image,
                    full: fullImage,
                    previewSrc: img.src,
                    fullSrc: img.fullSrc,
                    previewLoaded: !!image.getAttribute('src'),
                    fullLoaded: false,
                    fullLoading: false
                };

                /* Dot */
                var dot = document.createElement('button');
                dot.className = 'cfs-dot';
                dot.type = 'button';
                dot.setAttribute('role', 'tab');
                dot.setAttribute('aria-label', 'Slide ' + (i + 1));
                dot.setAttribute('aria-selected', i === current ? 'true' : 'false');
                ; (function (idx) {
                    dot.addEventListener('click', function () { moveTo(idx); rearm(); });
                }(i));
                dotsWrap.appendChild(dot);
            });

            /* ── Render — exact parameter match to reference ── */
            function updateSlides() {
                var allSlides = track.querySelectorAll('.cfs-slide');
                var dots = dotsWrap.querySelectorAll('.cfs-dot');

                allSlides.forEach(function (slide, i) {
                    /* Compute logical position relative to center — same as reference */
                    var pos = getPosition(i);

                    var absPos = Math.abs(pos);
                    var isCenter = pos === 0;
                    var isAdjacent = absPos === 1;
                    var visible = absPos <= 1;

                    /* Reference values — exactly matched */
                    var translateX = pos * 58;                               /* lateral glide (% of card width) */
                    var scale = isCenter ? 1 : isAdjacent ? 0.86 : 0.7;/* depth scale                     */
                    var rotateY = pos * -10;                              /* 3D tilt — gentle 10deg          */
                    var opacity = isCenter ? 1 : isAdjacent ? 0.62 : 0;  /* atmospheric fade                */
                    var zIndex = isCenter ? 20 : isAdjacent ? 10 : 1;   /* stacking                        */

                    slide.style.transform =
                        'translate(-50%, -50%) ' +
                        'translateX(' + translateX + '%) ' +
                        'scale(' + scale + ') ' +
                        'rotateY(' + rotateY + 'deg)';
                    slide.style.opacity = String(opacity);
                    slide.style.filter = 'none';
                    slide.style.zIndex = String(zIndex);
                    slide.style.visibility = visible ? 'visible' : 'hidden';
                });

                dots.forEach(function (dot, i) {
                    dot.setAttribute('aria-selected', i === current ? 'true' : 'false');
                });

                ensureVisibleSlides();
            }

            /* ── Navigation ────────────────────────────────── */
            function moveTo(idx) { current = mod(idx, total); updateSlides(); }

            prevBtn.addEventListener('click', function () { moveTo(mod(current - 1, total)); rearm(); });
            nextBtn.addEventListener('click', function () { moveTo(mod(current + 1, total)); rearm(); });

            /* Keyboard */
            root.setAttribute('tabindex', '0');
            root.addEventListener('keydown', function (e) {
                if (e.key === 'ArrowLeft') { moveTo(mod(current - 1, total)); rearm(); e.preventDefault(); }
                if (e.key === 'ArrowRight') { moveTo(mod(current + 1, total)); rearm(); e.preventDefault(); }
            });

            /* Hover pause */
            track.addEventListener('mouseenter', holdOn);
            track.addEventListener('mouseleave', holdOff);
            root.addEventListener('focusin', holdOn);
            root.addEventListener('focusout', function (e) {
                if (!root.contains(e.relatedTarget)) holdOff();
            });

            /* Window blur/focus */
            window.addEventListener('blur', holdOn);
            window.addEventListener('focus', holdOff);

            /* ── Drag / swipe ──────────────────────────────── */
            var startX = 0;
            var currentX = 0;
            var dragging = false;
            var moved = false;

            track.addEventListener('pointerdown', function (e) {
                if (total < 2) return;
                dragging = true;
                moved = false;
                startX = e.clientX;
                currentX = e.clientX;
                track.classList.add('is-dragging');
                holdOn();
            }, { passive: true });

            window.addEventListener('pointermove', function (e) {
                if (!dragging) return;
                currentX = e.clientX;
                if (Math.abs(currentX - startX) > 6) moved = true;
            }, { passive: true });

            window.addEventListener('pointerup', function () {
                if (!dragging) return;
                var dx = currentX - startX;
                dragging = false;
                track.classList.remove('is-dragging');
                if (Math.abs(dx) >= cfg.swipeThreshold) {
                    moveTo(mod(current + (dx < 0 ? 1 : -1), total));
                }
                holdOff();
            }, { passive: true });

            window.addEventListener('pointercancel', function () {
                dragging = false;
                track.classList.remove('is-dragging');
                holdOff();
            }, { passive: true });

            track.addEventListener('click', function (e) {
                if (!moved) return;
                e.preventDefault();
                e.stopPropagation();
                moved = false;
            }, true);

            track.addEventListener('dragstart', function (e) { e.preventDefault(); });

            /* ── Initial render + autoplay ─────────────────── */
            updateSlides();
            window.addEventListener('load', function () {
                window.setTimeout(function () {
                    autoplayReady = true;
                    fullUpgradeStarted = true;
                    warmRemainingPreviews();
                    warmFullImages();
                    arm();
                }, 3000);
            }, { once: true });
        }

        document.querySelectorAll('[data-cfs]').forEach(boot);

    })();
});
